export const RegionType = Object.freeze({
    // Also defined in Python.
    // Used in conjunction with an id to key into a SavedItem or Wrapper.
    KNOWN_ROUTE: 'known_route',
    LAND: 'land',
    TRAIL: 'trail',
    POI: 'poi',
    STATE: 'state',
    CITY: 'city',
    COUNTRY: 'country',
    NEARBY: 'nearby',
    MULTIPLE: 'multiple',
});
